import { Pipe, PipeTransform } from '@angular/core';
import { KVPair, Value } from 'src/app/types/kv';

@Pipe({
	name: 'kvPairListString'
})
export class KvPairListStringPipe implements PipeTransform {

	transform(data: Array<KVPair | Value>, kvSep: string, pairSep: string = ';'): string {
		let text = '';
		let isFirst: boolean;
		isFirst = true;
		for (const pair of data) {
			if (!isFirst) {
				text += kvSep
			}
			if (!!(pair as KVPair).k) {
				text += (pair as KVPair).k + pairSep;
				text += pair.v;
			} else {
				text += pair.v;
			}
			isFirst = false;

		}
		return text;
	}

}
